import React from 'react'
import { generateStatusStyle } from '../../orders/order_tracking/generateStatus'
import moment from 'moment'
import { status } from '../../orders/utils/trackingStatus'
import { Skeleton } from '@mui/material'

export default function DashboardTrackingsData({trackings, isLoading}) {
    const sliceTrackings = trackings?.length > 9 ? trackings.slice(0,10):trackings 
  return (
    <div>
        {sliceTrackings?.map((tracking) => (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {isLoading ? <Skeleton variant="rounded" height={30} width={100} sx={{marginBottom:'12px', marginRight:'5px'}} />:<h6 style={{ fontWeight: 600, color: "#797979" }}>
                {tracking.order_number}
              </h6>}
              {isLoading ? <Skeleton variant="rounded" height={30} width={100} sx={{marginBottom:'12px', marginRight:'5px'}}/>:<div> {generateStatusStyle(status(tracking))}</div>}
              {isLoading ? <Skeleton variant="rounded" height={30} width={100} sx={{marginBottom:'12px', marginRight:'5px'}}/>:<h6 style={{ fontWeight: 600, color: "#797979" }}>
                {moment(tracking.date_of_update).format('YYYY-MM-DD')}
              </h6>}
              {isLoading ? <Skeleton variant="rounded" height={30} width={100} sx={{marginBottom:'12px', marginRight:'5px'}}/>:<h6 style={{ fontWeight: 600, color: "#797979" }}>
                {tracking.time_in_transit} days
              </h6>}
            </div>
          ))}
    </div>
  )
}
